<template>
    <div class="course__edit_feedback_form">
        <div class="course__edit_feedback_form_header">
            <view-actions
                :title="'Create feedback form'"
                :notify-title="'feedback form'"
                :notify-process="'stop creating'"
                :cancel-button-text="'Cancel'"
                :submit-button-text="'Save feedback form'"
                :submit-button-animate-loading="true"
                :submit-button-animate-loading-event-name="'submit-feedback-form'"
                @emit-submit="performSubmitValidate"
                @emit-notify-cancel-submit="keyStopAdd"
            />
        </div>
        <div class="course__edit_feedback_form_main">
            <div class="container">
                <div class="columns">
                    <div class="column">
                        <lms-superadmin-workspace-edit-feedback-forms-edit-form></lms-superadmin-workspace-edit-feedback-forms-edit-form>
                    </div>
                </div>
            </div>
        </div>
        <pop-notify
            ref="popnotifyvalidation"
            :class="'pop__notify--validation'"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
    </div>
</template>

<script>

import { validateBeforeRouteLeave, performSubmitValidate } from '@/helpers/mixins'
import PopNotify from '@/components/default/shared/PopNotify'
import ViewActions from '@/components/default/shared/ViewActions'
import LmsSuperadminWorkspaceEditFeedbackFormsEditForm from '@/components/lms/superadmin/workspace/edit/LmsSuperadminWorkspaceEditFeedbackFormsEditForm'

export default {
  name: 'course-edit-feedbackForm',
  components: { LmsSuperadminWorkspaceEditFeedbackFormsEditForm, ViewActions, PopNotify },
  data () {
    return {
      requestPending: false
    }
  },
  mixins: [validateBeforeRouteLeave, performSubmitValidate],
  computed: {
    catalogItemFeedbackForm () {
      return this.$store.getters.getEbsCatalogItemFeedbackForm
    },
    workspaceFeedbackFormsEnabled () {
      return this.$store.getters.getLmsSuperadminWorkspaceFeedbackFormsEnabled
    },
    workspaceFeedbackFormDefault () {
      return this.$store.getters.getLmsSuperadminWorkspaceFeedbackFormsDefault
    },
    workspaceFeedbackFormSelectedFields () {
      const feedbackForm = this.$store.getters.getLmsSuperadminWorkspaceFeedbackFormsById(this.catalogItemFeedbackForm)
      return feedbackForm ? feedbackForm.fields : []
    },
    feedbackForms () {
      const getterName = this.isRouteCourse ? 'getEbsCourseFeedbackForm' : 'getEbsCatalogItemFeedbackForm'
      return this.$store.getters[getterName].definition
    },
    rootItemName () {
      return 'feedback-forms'
    },
    nameActionCreate () {
      return 'lmsSuperadminWorkspaceFeedbackFormCreate'
    },
    //
    isAddMode () {
      return this.$route.name.includes('-add')
    },
    isEditMode () {
      return this.$route.name.includes('-edit')
    },
    isShowMode () {
      return this.$route.name.includes('-show')
    },
    isRouteCourse () {
      return this.$route.name.includes('ebs-course-edit') || this.$route.name.includes('ebs-course-add')
    },
    isRouteCatalogItem () {
      return this.$route.name.includes('ebs-catalog-item-edit')
    },
    loggedInWorkspaceId () {
      return this.$store.getters.getAuthUserSecondStageTokenDataWorkspaceId
    },
    originCourseId () {
      return this.$route.params.courseId
    },
    originCatalogId () {
      return this.$route.params.catalogId
    },
    originVersionId () {
      return this.$route.params.versionId
    },
    courseWorkspaceSettingsWorkspaces () {
      return this.$store.getters.getEbsCatalogItemWorkspacesSettings
    }
  },
  methods: {
    keyStopAdd () {
      this.allowRedirectBeforeRouteLeave()
      this.$router.push({
        path: `/catalogue/courses/${this.originCourseId}/${this.originCatalogId}/${this.originVersionId}/edit/feedback`
      })
    },
    performSubmitValidateThenCallback (data) {
      this.$router.push({
        path: `/catalogue/courses/${this.originCourseId}/${this.originCatalogId}/${this.originVersionId}/edit/feedback`,
        query: { feedbackFormId: data.id }
      })
    },
    performSubmitValidateFinallyCallback () {
      this.$eventBus.$emit('stop-submit-feedback-form')
    },
    performSubmitValidateValidationCallback () {
      this.$eventBus.$emit('stop-submit-feedback-form')
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/courses/courseaddeditfeedbackform";
</style>
